import React from 'react';

import SimpleHeader from '../../../components/Headers/SimpleHeader'
import Form from './Form'

const Edit: React.FC = () => {

  return (
    <>
      <SimpleHeader name="Alterar Meta" parentName="Metas" />
      <Form />
    </>
  )
}

export default Edit;